import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";
import AuthService from "./auth.service";

class InternalDossierService {
  getTypes() {
    return axios
      .get(`${config.apiUrl}internal-dossier/types`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error::", err.response.data);
        return [];
      });
  }

  createFromPat(patId, bodyParms) {
    return axios
      .post(`${config["apiUrl"]}internal-dossier/pat/${patId}`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 201) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getPatDossiers(patId, dossierId) {
    return axios
      .get(
        `${config.apiUrl}internal-dossier/pat/${patId}/dossier/${dossierId}`,
        { headers: authHeader() }
      )
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error::", err.response.data);
        return [];
      });
  }

  addLine(data) {
    return axios
      .post(`${config.apiUrl}internal-dossier/line`, data, {
        headers: authHeader(),
      })
      .then((r) => r.data);
  }

  removeLine(lineId) {
    return axios
      .delete(
        `${config.apiUrl}internal-dossier/line/${encodeURIComponent(lineId)}`,
        {
          headers: authHeader(),
        }
      )
      .then((r) => r.data);
  }

  getConfigTypes() {
    return axios
      .get(
        `${config.apiUrl}internal-dossier/config/types`,
        {
          headers: authHeader(),
        }
      )
      .then((r) => r.data);
  }

  getFormConfig(dossierTypeId) {
    return axios
      .get(
        `${config.apiUrl}internal-dossier/types/${dossierTypeId}/config`,
        {
          headers: authHeader(),
        }
      )
      .then((r) => r.data);
  }

  createByType(type, data) {
    return axios
      .post(`${config.apiUrl}internal-dossier/store/${type}`, data, {
        headers: authHeader(),
      })
      .then((r) => r.data)
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        throw error;
      });
  }

  getDossiers(params) {
    return axios
      .get(`${config.apiUrl}internal-dossier`, {
        headers: authHeader(),
        params: params,
      })
      .then((r) => r.data);
  }

  getDossier(id) {
    return axios
      .get(`${config.apiUrl}internal-dossier/show/${id}`, {
        headers: authHeader(),
      })
      .then((r) => r.data);
  }

  getDossierDataFormConfig(stamp) {
    return axios
      .get(`${config.apiUrl}internal-dossier/config/dossier/${encodeURIComponent(stamp)}`, {
        headers: authHeader(),
      })
      .then((r) => r.data);
  }

  getConversionDraft(sourceType, targetType, sourceBostamp) {
    return axios
      .get(`${config.apiUrl}internal-dossier/convert-draft/${sourceType}/${targetType}/${encodeURIComponent(sourceBostamp)}`, {
        headers: authHeader(),
      })
      .then((r) => r.data);
  }

  updateByType(stamp, data) {
    return axios
      .put(`${config.apiUrl}internal-dossier/update/${encodeURIComponent(stamp)}`, data, {
        headers: authHeader(),
      })
      .then((r) => r.data)
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        throw error;
      });
  }

  getPatFormInternalDossier(patId, data) {
    return axios
      .post(`${config.apiUrl}internal-dossier/pat-form/${patId}`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getReportFile(stamp, body) {
    return axios
      .post(`${config.apiUrl}internal-dossier/report/${encodeURIComponent(stamp)}`, body, {
        headers: authHeader(),
        responseType: "blob",
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getClientInfoForDossier(stamp) {
    return axios
      .get(
        `${config.apiUrl}internal-dossier/client/${encodeURIComponent(stamp)}`,
        { headers: authHeader() }
      )
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error::", err.response.data);
        return [];
      });
  }

  sendReportEmail(stamp, body) {
    return axios
      .post(`${config.apiUrl}internal-dossier/send-report-email/${encodeURIComponent(stamp)}`, body, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  sendReportSms(stamp, body) {
    return axios
      .post(`${config.apiUrl}internal-dossier/send-report-sms/${encodeURIComponent(stamp)}`, body, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getMultipleConversionDraft(sourceBostamps, targetType, sourceBistamps = null) {
    return axios
      .post(`${config.apiUrl}internal-dossier/order-parts/convert-multiple-draft`, {
        source_bostamps: sourceBostamps,
        target_type: targetType,
        source_bistamps: sourceBistamps
      }, {
        headers: authHeader()
      })
      .then((res) => res.data);
  }

  getSupplierOrders(params) {
    return axios
      .get(`${config.apiUrl}internal-dossier/order-parts/supplier-orders`, {
        headers: authHeader(),
        params: params
      })
      .then((res) => res.data);
  }

  getClientOrderParts(params) {
    return axios
      .get(`${config.apiUrl}internal-dossier/order-parts/client-orders`, {
        headers: authHeader(),
        params: params
      })
      .then((res) => res.data);
  }

  getLgOrderPreview(bostamp) {
    return axios
      .get(`${config.apiUrl}internal-dossier/order-parts/lg-preview/${encodeURIComponent(bostamp)}`, {
        headers: authHeader()
      })
      .then((res) => res.data);
  }

  syncLgPart(payload) {
    return axios
      .post(`${config.apiUrl}internal-dossier/order-parts/sync-lg-part`, payload, {
        headers: authHeader()
      })
      .then((res) => res.data);
  }

}

export default new InternalDossierService();
